<template>
    <v-navigation-drawer
        fixed
        clipped
        app
        disable-route-watcher
        disable-resize-watcher
        v-model="display"
        class="site-menu"
    >
        <v-list>
            <template v-for="(item, i) in availableNavItems">
                  <v-list-group
                    v-if="item.children"
                    :key="item.text"
                    :prepend-icon="item.icon">

                    <v-list-tile slot="activator">
                            <v-list-tile-title>{{item.text}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list>
                        <template v-for="(child, j) in item.children">
                              <v-list-group class="removeAfter"
                                v-if="child.children"
                                :key="child.text"
                                :prepend-icon="child.icon">
                                <v-list-tile slot="activator">
                                    <v-list-tile-title>{{child.text}}</v-list-tile-title>
                                </v-list-tile>
                                         <template v-for="(childchild, k) in child.children">
                                                 <nav-item
                                                    v-if="childchild.route"
                                                    :key="k"
                                                    :item="childchild">
                                                    </nav-item>
                                         </template>
                              </v-list-group>
                            <nav-item
                            v-if="child.route"
                            :key="j"
                            :item="child">
                            </nav-item>
                         </template>
                    </v-list>
                  </v-list-group>


                <nav-item
                    v-if="item.route"
                    :key="i"
                    :item="item">
                </nav-item>
            </template>
           
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import navItem from "./NavItem.vue";
import auth from '@/services/auth';

export default {
    components: {
        navItem: navItem
    },
    data() {
        return {
            navItems: [
                {
                    icon: "home",
                    text: "Home",
                    route: "home"
                },
                {
                    icon: "list_alt",
                    text: "Orders",
                    children: [
                        {
                            icon: "create",
                            text: "Place Order",
                            route: "placeorder"
                        },
                        {
                            icon: "history",
                            text: "Previous Orders",
                            route: "previousorders"
                        }
                    ]
                },
                {
                    icon: "bar_chart",
                    text: "Reports",
                    children: [
                        {
                            icon: "bar_chart",
                            text: "Cost Report",
                            route: "costreport"
                        },
                        {
                            icon: "bar_chart",
                            text: "GP Report",
                            route: "orderreport"
                        },
                        {
                            icon: "bar_chart",
                            text: "Products",
                            route: "productreport"
                        },
                        {
                            icon: "bar_chart",
                            text: "Supplier Order Listing",
                            route: "orderssentreport"
                        }
                    ]
                },
                {
                    icon: "ballot",
                    text: "Audit",
                    children: [
                        {
                            icon: "list",
                            text: "Audit Log",
                            route: "auditlog"
                        },
                        {
                            icon: "attach_money",
                            text: "Banking Details",
                            children: [
                                {
                                    text: "John Chapley Group",
                                    route: "bankingdetailsjcg",
                                    icon:  "attach_money"
                                },
                                {
                                    text: "CGMS",
                                    route: "bankingdetailssbd",
                                    icon:  "attach_money"
                                },
                                {
                                    text: "CRG",
                                    route: "bankingdetailscrg",
                                    icon:  "attach_money"
                                },
                                {
                                    text: "Supplier Audit",
                                    route: "bankingdetailscg",
                                    icon:  "attach_money"
                                }
                            ]
                           
                        }
                    ]
                },
                {
                    icon: "view_list",
                    text: "Data Management",
                    children: [
                        {
                            icon: "commute",
                            text: "Assign Suppliers",
                            route: "assignsuppliers"
                        },
                        {
                            icon: "event",
                            text: "Public Holidays",
                            route: "publicholidays"
                        },
                         {
                            icon: "commute",
                            text: "Assign To Stores",
                            route: "assigntostores"
                        }
                    ]
                },
                {
                    icon: "security",
                    text: "Administration",
                    children: [
                        {
                            icon: "group",
                            text: "User Management",
                            route: "users"
                        },
                        {
                            icon: "store",
                            text: "Stores and Departments",
                            route: "storesanddepartments"
                        },
                        {
                            icon: "shopping_cart",
                            text: "Product Management",
                            route: "products"
                        },
                        {
                            icon: "category",
                            text: "Category Management",
                            route: "categories"
                        },
                        {
                            icon: "fastfood",
                            text: "Supplier Management",
                            route: "suppliers"
                        }
                    ]
                },
                {
                    icon: "keyboard_return",
                    text: "Logout",
                    route: "logout"
                },
            ]
        };
    },
    computed: {
        display: {
            get() {
                return this.$store.state.generalStore.displayNavDrawer;
            },
            set(value) {
                this.$store.commit("generalStore/setDisplayNavDrawer", value);
            }
        },
        availableNavItems() {
            let routes = this.$router.options.routes;
            let includeRoute = function(routeToCheck){
                for(let i = 0; i < routes.length; i++){
                    let route = routes[i];
                    
                    if(route.name === routeToCheck){
                        return !route.meta || !route.meta.requiredPermissions || auth.hasPermissions(route.meta.requiredPermissions)
                    }
                }

                return false;
            }

            let shallowCopy = function(obj){
                let newObj = {};
                for(let property in obj){
                    if(obj.hasOwnProperty(property)){
                        newObj[property] = obj[property];
                    }
                }
                return newObj;
            }

            let availableNavItems = [];
            let navItems = this.navItems;

            navItems.forEach(navItem => {
                if(navItem.route){
                    if(includeRoute(navItem.route)){
                        availableNavItems.push(navItem);
                    }
                } else if(navItem.children){
                    var newNavItem = shallowCopy(navItem);
                    newNavItem.children = [];

                    navItem.children.forEach(child => {
                        if(includeRoute(child.route)){
                            newNavItem.children.push(child);
                        } else if(child.children) {
                             var newNavItemChild = shallowCopy(child);
                             newNavItemChild.children = [];
                             child.children.forEach(child => {
                                if(includeRoute(child.route)){
                                    newNavItemChild.children.push(child);
                                }
                             })
                              if(newNavItemChild.children.length > 0){
                                newNavItem.children.push(newNavItemChild);
                            }
                        }
                    });

                    if(newNavItem.children.length > 0){
                        availableNavItems.push(newNavItem);
                    }
                }
            });
            return availableNavItems;
        }
    },
    methods: {
        navigate(item) {
            this.$router.push({ name: item.route });

            this.$store.commit("generalStore/hideNavDrawer");
        }
    }
};
</script>

<style>
.removeAfter:after {
    display:none;
}
</style>
